import React from 'react';
import styles from './index.module.less';
import AgeGateModal from 'mod/age-gate/AgeGateModal';
import SiteLogo from '@pro/common/SiteLogo';
import { isPhone } from 'base/utils/client';

type IProps = {
    pageProps?: Record<string, any>
}

const AgeGatePopup: React.FC<IProps> = (props) => {
    const { pageProps } = props

    const { ageLimit = false } = pageProps || {}

    return (
        <AgeGateModal
            serverAgeLimit={ageLimit}
            modalClassName={styles['age-gate-modal']}
            className={styles['age-gate']}
            logo={
                <SiteLogo
                    type={'primary'}
                    size={isPhone ? 206 : 412}
                    fixed={false}
                    href={false}
                />
            }
            btnYesProps={{
                type: 'primary'
            }}
            btnNotProps={{
                type: 'primary',
                ghost: true
            }}
        />
    );
};

export default AgeGatePopup